"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useState, useCallback, useMemo } from "react";
import { useLocalStorage } from "../../hooks/useLocalStorage/index.js";
import { STW_MY_WAREHOUSE_LOCAL_STORAGE_KEY, STW_POSTAL_CODE_LOCAL_STORAGE_KEY } from "./localStorage.js";
const COMPONENT_NAME = "StwInfoProvider";
const StwContext = createContext(null);
const initVals = {
  stwMyWarehouse: "",
  stwPostalCode: ""
};
const StwInfoContextProvider = ({
  children,
  initialValues = initVals
}) => {
  const [stwInfo, setStwInfo] = useState(initialValues);
  const [stwMyWarehouseLocalStorage, setStwMyWarehouseLocalStorage] = useLocalStorage(STW_MY_WAREHOUSE_LOCAL_STORAGE_KEY, void 0);
  const [stwPostalCodeLocalStorage, setStwPostalCodeLocalStorage] = useLocalStorage(STW_POSTAL_CODE_LOCAL_STORAGE_KEY, void 0);
  const updateStwInfoState = useCallback(
    (newInfo, options = {}) => {
      const finalOptions = {
        updateState: true,
        updateStorage: true,
        ...options
      };
      if (finalOptions.updateStorage) {
        if ("stwMyWarehouse" in newInfo) {
          setStwMyWarehouseLocalStorage(newInfo.stwMyWarehouse);
        }
        if ("stwPostalCode" in newInfo) {
          setStwPostalCodeLocalStorage(newInfo.stwPostalCode);
        }
      }
      if (finalOptions.updateState) {
        const stateUpdate = {};
        if ("stwMyWarehouse" in newInfo) {
          stateUpdate.stwMyWarehouse = newInfo.stwMyWarehouse ?? "";
        }
        if ("stwPostalCode" in newInfo) {
          stateUpdate.stwPostalCode = newInfo.stwPostalCode ?? "";
        }
        setStwInfo((prevState) => ({ ...prevState, ...stateUpdate }));
      }
    },
    [setStwMyWarehouseLocalStorage, setStwPostalCodeLocalStorage]
  );
  const stwInfoObj = useMemo(() => {
    return {
      ...stwInfo,
      // local state
      stwMyWarehouseLocalStorage,
      stwPostalCodeLocalStorage,
      updateStwInfo: updateStwInfoState
    };
  }, [
    stwInfo,
    stwMyWarehouseLocalStorage,
    stwPostalCodeLocalStorage,
    updateStwInfoState
  ]);
  return /* @__PURE__ */ jsx(StwContext.Provider, { value: stwInfoObj, children });
};
StwInfoContextProvider.displayName = COMPONENT_NAME;
export {
  StwContext,
  StwInfoContextProvider
};
